import { createContext } from 'react';

const SubContext = createContext();

export default SubContext;
